import { render, staticRenderFns } from "./FoldersList.vue?vue&type=template&id=3df6abaa"
import script from "./FoldersList.vue?vue&type=script&lang=ts"
export * from "./FoldersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports